<template>
  <div>
    <v-row>
      <v-col class="d-flex flex-1 align-center justify-space-between pb-5">
        <span class="header bold text-tcdc-green">{{article[`subject_${lang}`]}}</span>
        <ShareButton mode="article"></ShareButton>
      </v-col>
    </v-row>
    <!-- <v-row>
      <v-col>
        <div class="d-flex flex-1 align-center">
          <div class="pr-3 d-flex align-center">
            <img src="../../assets/icons/sorts/calendar.png" class="eventdetail-card-logo mr-4" />
            <span class="bold text-uppercase text-tcdc-green">14 aug - 13 oct 2019</span>
          </div>
          <div class="d-flex align-center">
            <img src="../../assets/icons/marker.png" class="eventdetail-card-logo mr-4" />
            <span class="bold text-uppercase text-tcdc-green">TCDC BANGKOK</span>
          </div>
        </div>
      </v-col>
    </v-row>-->
    <v-row>
      <v-col>
        <span class="text-tcdc-grey1 bold mr-4">Publish date {{article.article_date | moment('DD MMM')}}</span>
        <img src="../../assets/icons/generals/view.png" class="tcdc-view-icon mr-2" />
        <span class="text-tcdc-grey1 bold mr-4">{{formatNumber(article.article_view)}}</span>
      </v-col>
    </v-row>
    <!-- section 1 -->
    <v-row class="mb-5">
      <v-col>
        <v-img :src="article.cover_img_path" aspect-ratio="1.7"></v-img>
<!--        <ImageCarousel />-->
      </v-col>
    </v-row>
    <v-row>
      <v-col class="pt-0" >
        <div
          class="text-tcdc-green bold vhtml"
          v-html="article[`intro_${lang}`]"
        ></div>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <div class="vhtml" v-html="article[`detail_${lang}`]">
        </div>
      </v-col>
    </v-row>

    <!-- section 2 -->
<!--    <v-row>-->
<!--      <v-col>-->
<!--        <ImageCarousel />-->
<!--      </v-col>-->
<!--    </v-row>-->
    <!-- <v-row>
      <v-col>
        <span class="sub-header1">
          Grounded on the idea that design and
          creativity cannot exist withoutcultural foundation and intellectual accumulation of knowledge.
        </span>
      </v-col>
    </v-row>-->

    <!-- section relate article -->
<!--    <v-row class="pt-8">-->
<!--      <v-col>-->
<!--        <span class="text-tcdc-green sub-header1 bold text-uppercase">related article</span>-->
<!--      </v-col>-->
<!--    </v-row>-->
<!--    <v-row class="d-flex flex-wrap">-->
<!--      <template v-for="(item, index) of articles">-->
<!--        <v-col cols="12" md="6" :key="index">-->
<!--          &lt;!&ndash; <EventCard-->
<!--            class="cursor-pointer"-->
<!--            :name="item.name"-->
<!--            :time_start="item.start_date"-->
<!--            :time_end="item.end_date"-->
<!--            :place="item.place"-->
<!--            @click.native="eventDetailHandler"-->
<!--          />&ndash;&gt;-->
<!--          <ArticleCard :border="false" />-->
<!--        </v-col>-->
<!--      </template>-->
<!--    </v-row>-->
  </div>
</template>

<script>
import ArticleCard from "../../components/cards/ArticleCard";
import ImageCarousel from "../../components/carousels/ImageCarousel";
import ShareButton from "../buttons/ShareButton";
import { mapState } from 'vuex';

export default {
  components: {
    // ArticleCard,
    // ImageCarousel,
    ShareButton
  },
  methods: {
    eventDetailHandler() {
      const eventId = 2;
      this.$router.push(`/events/${eventId}`);
    },
    formatNumber(num) {
      return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }
  },
  computed: {
    ...mapState({
      article: state => state.Article.article,
      lang: state => state.Branch.lang
    })
  },
  data: () => ({
    articles: [
      {
        name: "master of materials",
        time: "14 Aug - 13 Oct 2019",
        place: "TCDC Bangkok",
        highlight: false
      },
      {
        name: "master of materials",
        time: "14 Aug - 13 Oct 2019",
        place: "TCDC Bangkok",
        highlight: false
      }
    ]
  })
};
</script>

<style scoped>
.eventdetail-card-logo {
  height: 25px;
  object-fit: contain;
}
</style>
